import authenticatedFetcher from './authenticatedFetcher';
import firebase from 'firebase/app';
import { Summary } from 'services/hitchit/types/admin/Summary';
import {
  PreferenceChoicesResponse,
  PreviewResponse,
} from 'services/hitchit/types/usecases/Preference';
import { TriggerDataResponse } from 'services/hitchit/types/usecases/OrderToDeal';

type PreferenceChoicesQuery = {
  id: string;
  user?: firebase.User;
};

type TriggerDataQuery = {
  id: string;
  limit?: number;
  user?: firebase.User;
};

export async function getTriggerData({
  id,
  limit,
  user,
}: TriggerDataQuery): Promise<TriggerDataResponse | undefined> {
  if (!user) {
    return;
  }
  return authenticatedFetcher(`/hike/${id}/triggerdata?limit=${limit || 10}`, user);
}

export async function getPreferenceChoices({
  id,
  user,
}: PreferenceChoicesQuery): Promise<PreferenceChoicesResponse<PreviewResponse> | undefined> {
  if (!user) {
    return;
  }
  return authenticatedFetcher(`/hike/${id}/preferences`, user);
}

export async function getShopifyScopes(
  hitchRef: string,
  user: firebase.User
): Promise<{ scopes: string[]; shopName: string }> {
  return authenticatedFetcher(`/shopify-scopes/${hitchRef}`, user);
}

export async function getUserSummary(adminUser: firebase.User): Promise<Summary> {
  return authenticatedFetcher(`/admin/users`, adminUser);
}
